<template>
  <div>
    <div class="scanner" v-if="!result">
      <span class="badge" v-bind:class="statusClass">{{ statusText }}</span>
      <v-quagga
        :onDetected="logIt"
        :readerSize="readerSize"
        :readerTypes="['ean_reader']"
      ></v-quagga>
    </div>
    <div class="container">
      <div v-if="result" class="d-flex flex-column align-items-center">
        <span
          class="badge badge-primary badge-pill"
          v-if="this.bookData.volumeInfo.categories"
        >
          {{ this.bookData.volumeInfo.categories | toString }}
        </span>
        <h1 v-if="this.bookData.volumeInfo.title">
          {{ this.bookData.volumeInfo.title }}
        </h1>
        <h4 v-if="this.bookData.volumeInfo.authors">
          von <span>{{ this.bookData.volumeInfo.authors | toString }}</span>
        </h4>
        <img
          v-if="this.bookData.volumeInfo.imageLinks.thumbnail"
          :src="this.bookData.volumeInfo.imageLinks.thumbnail"
        />
        <div type="button" class="btn btn-success" @click="addBookToDB()">
          Submit
        </div>
        <hr />
        <p v-if="this.bookData.volumeInfo.description">
          {{ this.bookData.volumeInfo.description }}
        </p>
        <pre>{{ this.newBook }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import firebase from 'firebase';

const auth = firebase.auth();

export default {
  data() {
    return {
      isbn: null,
      bookData: null,
      result: null,
      statusClass: '',
      statusText: '',
      readerSize: {
        width: 640,
        height: 480,
      },
      detecteds: [],
      newBook: {
        author: '',
        title: '',
        description: '',
        isbn: '',
        cover: '',
        tags: '',
        category: '',
        createdAt: new Date(),
        isBorrowed: false,
      },
    };
  },
  created() {
    console.log(process.env);
    auth.onAuthStateChanged(loggedinUser => {
      if (loggedinUser) {
        this.loggedinUser = loggedinUser;
      } else {
        this.loggedinUser = null;
        this.$router.push('/login');
      }
    });
  },
  methods: {
    addBookToDB() {
      let vm = this;
      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('books')
          .add({
            owner: firebase.auth().currentUser.uid,
            author: this.newBook.author || '',
            title: this.newBook.title || '',
            subtitle: this.newBook.subtitle || '',
            description: this.newBook.description || '',
            isbn: this.newBook.isbn || '',
            cover: this.newBook.cover || '',
            category: this.newBook.category || '',
            createdAt: new Date(),
            isBorrowed: false,
          })
          .then(function() {
            // console.log('Book successfully written!');
            vm.result = null;
            vm.statusText = null;
          });
      }
    },
    logIt(data) {
      // console.log('detected', data);
      this.statusText = 'Detected';
      this.statusClass = 'badge-success';
      this.result = data.codeResult.code;
      this.searchForBookByCode(data.codeResult.code);
    },
    searchForBookByCode(barcode) {
      this.statusText = 'Scan Code...';
      this.statusClass = 'badge-primary';
      if (barcode) {
        axios
          .get(
            'https://www.googleapis.com/books/v1/volumes?q=' +
              barcode +
              '&key=' +
              process.env.VUE_APP_GBS_TOKEN,
          )
          .then(res => {
            if (res.data.totalItems > 0 && res.data.items[0].volumeInfo) {
              this.bookData = res.data.items[0];
              console.log(res);
              let isbnObject = this.bookData.volumeInfo.industryIdentifiers.find(
                el => el.type === 'ISBN_13',
              );
              this.bookData.ISBN13 = isbnObject['identifier'];
              // console.log('isbn13: ', this.bookData.ISBN13);

              this.statusText = 'Ergebnis gefunden';
              this.statusClass = 'badge-success';

              this.newBook.owner = firebase.auth().currentUser.uid;
              this.newBook.author =
                this.bookData.volumeInfo.authors.toString() ||
                this.bookData.volumeInfo.author.toString() ||
                '';
              this.newBook.title = this.bookData.volumeInfo.title || '';
              this.newBook.subtitle = this.bookData.volumeInfo.subtitle || '';
              this.newBook.description =
                this.bookData.volumeInfo.description || '';
              this.newBook.isbn = this.bookData.ISBN13 || '';
              this.newBook.cover =
                this.bookData.volumeInfo.imageLinks.large || '';
              this.newBook.category = this.bookData.volumeInfo.category || '';
              this.newBook.createdAt = new Date();
              this.newBook.isBorrowed = false;

              // this.result = res;
            } else {
              this.statusText = 'Kein Buch gefunden';
              this.statusClass = 'badge-warning';
              this.result = null;
            }
          })
          .catch(err => {
            this.statusText = err;
            this.statusClass = 'badge-danger';
          });
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
